import { ArrowRight, CaretLeft, CheckCircle } from "@phosphor-icons/react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import useLinkedAccounts from "../../../hooks/useLinkedAccounts";

const COMPLIANCE_HOME = "/home/settings/compliance";

const UpgradeTier2 = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { accounts } = useLinkedAccounts();

  const employmentDone =
    !!user?.compliance?.employment_status ||
    !!user?.compliance?.added_employment_status;

  const bankAccountDone = (accounts?.data?.length || 0) > 0;

  const completedCount = [employmentDone, bankAccountDone].filter(Boolean).length;
  const totalCount = 2;

  return (
    <div className="flex items-center justify-center gap-10 md:px-5 md:py-5 pb-20 flex-col">
      <div className="flex-col gap-4 flex items-start justify-center w-full max-w-[32rem]">
        <div className="bg-white p-8 border border-gray-200 rounded-xl w-full flex flex-col gap-6">

          {/* Back */}
          <button
            type="button"
            onClick={() => navigate("/home/settings/compliance/kyc")}
            className="p-2 text-center text-deepBlue border px-6 rounded-xl font-medium flex gap-2 items-center border-gray-300 self-start"
          >
            <CaretLeft weight="bold" size={20} />
          </button>

          {/* Header */}
          <div className="flex flex-col gap-1">
            <h1 className="font-medium text-3xl">Upgrade to Tier 2</h1>
            <div className="text-gray-500 text-sm">
              Complete both requirements below to unlock higher daily and loan limits.
            </div>
          </div>

          {/* Progress */}
          <div className="flex items-center gap-3">
            <div className="flex-1 h-2 rounded bg-gray-200">
              <div
                className="h-full rounded bg-deepBlue transition-all"
                style={{ width: `${(completedCount / totalCount) * 100}%` }}
              />
            </div>
            <div className="text-sm text-gray-500 whitespace-nowrap">
              {completedCount} of {totalCount} completed
            </div>
          </div>

          {/* Requirements */}
          <div className="flex flex-col gap-4">

            {/* Employment */}
            {employmentDone ? (
              <div className="flex items-center gap-4 rounded-xl border border-gray-200 p-4 bg-gray-50/50">
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-gray-900">Employment Information</div>
                  <div className="text-sm text-gray-500 mt-0.5">Your employment details are on file.</div>
                </div>
                <CheckCircle size={28} weight="fill" className="text-green-600 shrink-0" />
              </div>
            ) : (
              <Link
                to={`${COMPLIANCE_HOME}/employment-details`}
                className="flex items-center gap-4 rounded-xl border border-gray-200 p-4 bg-gray-50/50 hover:bg-amber-50/40 hover:border-amber-200 transition-colors"
              >
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-gray-900">Employment Information</div>
                  <div className="text-sm text-gray-500 mt-0.5">
                    Add your employment details to continue.
                  </div>
                </div>
                <ArrowRight size={22} className="text-amber-500 shrink-0" />
              </Link>
            )}

            {/* Bank Account */}
            {bankAccountDone ? (
              <div className="flex items-center gap-4 rounded-xl border border-gray-200 p-4 bg-gray-50/50">
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-gray-900">Bank Account</div>
                  <div className="text-sm text-gray-500 mt-0.5">Your bank account is linked.</div>
                </div>
                <CheckCircle size={28} weight="fill" className="text-green-600 shrink-0" />
              </div>
            ) : (
              <Link
                to={`${COMPLIANCE_HOME}/bank-accounts`}
                className="flex items-center gap-4 rounded-xl border border-gray-200 p-4 bg-gray-50/50 hover:bg-amber-50/40 hover:border-amber-200 transition-colors"
              >
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-gray-900">Bank Account</div>
                  <div className="text-sm text-gray-500 mt-0.5">
                    Link a bank account to continue.
                  </div>
                </div>
                <ArrowRight size={22} className="text-amber-500 shrink-0" />
              </Link>
            )}
          </div>

          {/* Footer back link */}
          <div className="pt-2 border-t border-gray-200">
            <Link
              to={COMPLIANCE_HOME}
              className="text-sm font-medium text-deepBlue hover:underline"
            >
              View all compliance tasks
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpgradeTier2;
